import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/providers/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sm-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {

  constructor(private _navService:NavigationService) {
    this._navService.hideSidebarAndNav = true;
   }

  ngOnInit(): void {
  }

  openBusinessFeatures(){
    window.open(environment.base_lookzup_web_url + '/business/business-all-features', '_blank');
  }
  openLookzup(){
    window.open(environment.base_lookzup_web_url, '_blank');
  }
}
